// Permission constants matching the backend PermissionSeeder.
// Use these instead of hardcoded strings for type-safety and autocomplete.

export const PERMISSIONS = {
  // Dashboard
  DASHBOARD_DEFAULT: 'Dashboard.Default',
  DASHBOARD_ADMIN: 'Dashboard.Admin',
  DASHBOARD_SELLER: 'Dashboard.Seller',
  DASHBOARD_PICKER: 'Dashboard.Picker',
  DASHBOARD_CONTENT: 'Dashboard.ContentManager',

  // Orders
  ORDERS_VIEW: 'Orders.View',
  ORDERS_VIEW_PRICES: 'Orders.ViewPrices',
  ORDERS_FILTER_BY_SELLER: 'Orders.FilterBySeller',
  ORDERS_SELECT_ITEMS: 'Orders.SelectItems',
  ORDERS_ASSIGN_SELLER_INVOICE: 'Orders.AssignSellerInvoice',
  ORDERS_ASSIGN_TO_TAMINZO: 'Orders.AssignToTaminzo',
  ORDERS_RESYNC: 'Orders.Resync',
  ORDERS_RECALC_PRICE: 'Orders.RecalcPrice',
  ORDERS_CANCEL: 'Orders.Cancel',
  ORDERS_MARK_PICKED: 'Orders.MarkPicked',
  ORDERS_MARK_TRANSFER: 'Orders.MarkTransfer',
  ORDERS_VIEW_TIMELINE: 'Orders.ViewTimeline',
  ORDERS_FULFILL: 'Orders.Fulfill',
  ORDERS_RETURNS: 'Orders.Returns',

  // Products
  PRODUCTS_VIEW: 'Products.View',
  PRODUCTS_FILTER_BY_SELLER: 'Products.FilterBySeller',
  PRODUCTS_VIEW_SHOPIFY_ID: 'Products.ViewShopifyId',
  PRODUCTS_CREATE: 'Products.Create',
  PRODUCTS_EDIT: 'Products.Edit',
  PRODUCTS_BULK_EDIT: 'Products.BulkEdit',
  PRODUCTS_DISABLE: 'Products.Disable',
  PRODUCTS_DELETE: 'Products.Delete',
  PRODUCTS_APPROVE: 'Products.Approve',
  PRODUCTS_RESYNC: 'Products.Resync',
  PRODUCTS_QRCODE: 'Products.QRCode',
  PRODUCTS_EXPORT: 'Products.Export',
  PRODUCTS_STOCK_REPORT: 'Products.StockReport',
  PRODUCTS_PRINT_LABELS: 'Products.PrintLabels',
  PRODUCTS_FIX_SKU: 'Products.FixSku',
  PRODUCTS_FIX_BARCODE: 'Products.FixBarcode',

  // Tools
  QRCODE_GENERATE: 'QRCode.Generate',

  // Product Drafts
  PRODUCT_DRAFTS_VIEW: 'ProductDrafts.View',

  // Pickup List
  PICKUP_LIST_VIEW: 'PickupList.View',
  PICKUP_LIST_FILTER_BY_SELLER: 'PickupList.FilterBySeller',
  PICKUP_LIST_ASSIGN_SELLER_INVOICE: 'PickupList.AssignSellerInvoice',
  PICKUP_LIST_RESYNC: 'PickupList.Resync',
  PICKUP_LIST_PRINT: 'PickupList.Print',
  PICKUP_LIST_MARK_PICKED: 'PickupList.MarkPicked',

  // Return List
  RETURN_LIST_VIEW: 'ReturnList.View',
  RETURN_LIST_FILTER_BY_SELLER: 'ReturnList.FilterBySeller',
  RETURN_LIST_PRINT: 'ReturnList.Print',

  // Ledger
  LEDGER_VIEW: 'Ledger.View',
  LEDGER_VIEW_FINANCIALS: 'Ledger.ViewFinancials',
  LEDGER_FILTER_BY_SELLER: 'Ledger.FilterBySeller',
  LEDGER_TOGGLE_STATUS: 'Ledger.ToggleStatus',

  // Invoices
  INVOICES_VIEW: 'Invoices.View',
  INVOICES_VIEW_SELLER_SUMMARY: 'Invoices.ViewSellerSummary',
  INVOICES_FILTER_BY_SELLER: 'Invoices.FilterBySeller',
  INVOICES_DOWNLOAD_PDF: 'Invoices.DownloadPdf',
  INVOICES_MARK_PAID: 'Invoices.MarkPaid',
  INVOICES_DELETE: 'Invoices.Delete',
  INVOICES_GENERATE: 'Invoices.Generate',
  INVOICES_CREATE_ADJUSTMENT: 'Invoices.CreateAdjustment',

  // Order Discounts
  DISCOUNTS_VIEW: 'Discounts.View',
  DISCOUNTS_CREATE: 'Discounts.Create',
  DISCOUNTS_EDIT: 'Discounts.Edit',
  DISCOUNTS_DELETE: 'Discounts.Delete',

  // Users
  USERS_VIEW: 'Users.View',
  USERS_CREATE: 'Users.Create',
  USERS_EDIT: 'Users.Edit',
  USERS_CHANGE_PASSWORD: 'Users.ChangePassword',
  USERS_DELETE: 'Users.Delete',

  // Sellers
  SELLERS_VIEW: 'Sellers.View',
  SELLERS_CREATE: 'Sellers.Create',
  SELLERS_EDIT: 'Sellers.Edit',
  SELLERS_DELETE: 'Sellers.Delete',

  // Brands
  BRANDS_VIEW: 'Brands.View',
  BRANDS_CREATE: 'Brands.Create',
  BRANDS_EDIT: 'Brands.Edit',
  BRANDS_DELETE: 'Brands.Delete',

  // Seller-Brand Relationships
  SELLER_BRANDS_VIEW: 'SellerBrands.View',
  SELLER_BRANDS_MANAGE: 'SellerBrands.Manage',
  SELLER_BRANDS_VIEW_COMMISSION: 'SellerBrands.ViewCommission',
  SELLER_BRANDS_SET_COMMISSION: 'SellerBrands.SetCommission',
  SELLER_BRANDS_SHOPIFY_CONNECT: 'SellerBrands.ShopifyConnect',
  SELLER_BRANDS_VIEW_WAREHOUSE: 'SellerBrands.ViewWarehouse',

  // Historical Sync / Product Mapping
  HISTORICAL_SYNC_VIEW: 'HistoricalSync.View',
  HISTORICAL_SYNC_MAP: 'HistoricalSync.Map',
  HISTORICAL_SYNC_CREATE_DRAFT: 'HistoricalSync.CreateDraft',

  SHOPIFY_SYNC_CONFIG_MANAGE: 'ShopifySyncConfig.Manage',
  // Roles & Permissions Management
  ROLES_VIEW: 'Roles.View',
  ROLES_MANAGE: 'Roles.Manage',
  ROLES_RESTORE_DEFAULTS: 'Roles.RestoreDefaults',

  // Product Types
  PRODUCT_TYPES_VIEW: 'ProductTypes.View',
  PRODUCT_TYPES_MANAGE: 'ProductTypes.Manage',

  // Product Tags
  PRODUCT_TAGS_VIEW: 'ProductTags.View',
  PRODUCT_TAGS_MANAGE: 'ProductTags.Manage',

  // Product Options
  PRODUCT_OPTIONS_VIEW: 'ProductOptions.View',
  PRODUCT_OPTIONS_MANAGE: 'ProductOptions.Manage',

  // Custom Fields
  CUSTOM_FIELDS_VIEW: 'CustomFields.View',
  CUSTOM_FIELDS_MANAGE: 'CustomFields.Manage',

  // Market Price Uplifts
  MARKET_PRICE_UPLIFTS_MANAGE: 'MarketPriceUplifts.Manage',

  // Marketing Collections
  MARKETING_COLLECTIONS_MANAGE: 'MarketingCollections.Manage',

  // Competitor Analysis
  COMPETITOR_ANALYSIS_VIEW: 'CompetitorAnalysis.View',

  // Customer Risk
  CUSTOMERS_VIEW_RISK: 'Customers.ViewRisk',
  CUSTOMERS_BLACKLIST: 'Customers.Blacklist',

  // Marketing
  MARKETING_PUSH: 'Marketing.Push',
  MARKETING_PUSH_ANALYTICS: 'Marketing.PushAnalytics',

  // Storefront Search
  SEARCH_VIEW_ANALYTICS: 'Search.ViewAnalytics',
  SEARCH_VIEW_MAPPINGS: 'Search.ViewMappings',
  SEARCH_MANAGE_MAPPINGS: 'Search.ManageMappings',
  SEARCH_REINDEX: 'Search.Reindex',
  SIZE_CATEGORIES_MANAGE: 'SizeCategories.Manage',
  COLOR_FAMILIES_MANAGE: 'ColorFamilies.Manage',
  SEARCH_MANAGE_FILTERS: 'Search.ManageFilters',
  SEARCH_DELETE_FILTERS: 'Search.DeleteFilters',
  IMAGE_VECTORS_MANAGE: 'ImageVectors.Manage',
  CATALOGS_MANAGE_RULES: 'Catalogs.ManageRules',
  WHATSAPP_BUTTON_MANAGE: 'WhatsAppButton.Manage',
} as const;

export type PermissionName = typeof PERMISSIONS[keyof typeof PERMISSIONS];
